import { useAccountContext } from '../useAccountContext';

export const useCompanyId = () => {
  const { currentCompany } = useAccountContext();

  return currentCompany?.id as string;
};
